import LightLayout from '../../../../../shared/Layouts/LightLayout'
import taskSandboxCss from '../taskSandbox.module.css'
import css from '../EleventhTypeSandbox/eleventhTaskSandbox.module.css'
import sandboxCss from '../taskSandbox.module.css'
import { memo, useState } from 'react'
import CreateImageOptionModal from '../../CreateImageOptionModal'
import { IDraftImage, IImage, ITask } from '../../../../../types/tasks.types'
import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../../sandbox.atom'
import { ReactComponent as RemoveIcon } from '../../../../../asserts/icons/xmark.svg'
import { IOption } from '../../../../../shared/Inputs/Dropdown'
import InlineSelect from '../../../../../shared/Inputs/InlineSelect'
import UpdateOrderingIndexModal from '../../UpdateOrderingIndexModal'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const options: IOption<'text_and_image' | 'images'>[] = [
  { value: 'text_and_image', title: 'Текст и картинка' },
  { value: 'images', title: 'Только картинки' },
]

const SixteenthTaskSandbox = (props: IProps) => {
  const { draftTask } = useRecoilValue(sandboxAtom)
  const [open, setOpen] = useState(false)

  const sortedImages = [...draftTask.images].sort((a, b) => a.orderingIndex - b.orderingIndex)

  const handleOptionDelete = (index: number) => {
    props.onDraftTaskChange([...sortedImages.slice(0, index), ...sortedImages.slice(index + 1)] as any, 'images')
  }

  const handleOptionUpdate = (index: number, updates: Partial<IImage>) => {
    props.onDraftTaskChange(
      [
        ...sortedImages.slice(0, index),
        { ...sortedImages[index], ...updates },
        ...sortedImages.slice(index + 1),
      ] as any,
      'images'
    )
  }

  const handleCreate = (option: IDraftImage) => {
    props.onDraftTaskChange([...(sortedImages as IDraftImage[]), option], 'images')
    setOpen(false)
  }

  const renderOptions = () => {
    return sortedImages.map((option, index) => (
      <ImageOption
        option={option}
        // @ts-ignore
        key={option.id ?? index}
        index={index}
        onDelete={handleOptionDelete}
        onUpdate={handleOptionUpdate}
      />
    ))
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      {open && <CreateImageOptionModal onClose={() => setOpen(false)} onCreate={handleCreate} isAnswer={true} />}
      <LightLayout>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
          <InlineSelect
            value={draftTask.type === 16 ? 'images' : 'text_and_image'}
            options={options}
            onChange={(v) => props.onDraftTaskChange(v === 'images' ? 16 : 8, 'type')}
          />
        </div>
        <div className={css.wrapper} style={{ padding: '64px' }}>
          <div style={{ display: 'inline-flex', gap: '64px' }}>
            {renderOptions()}
            <div className={sandboxCss.addOption} onClick={() => setOpen(true)}>
              Добавить карточку
            </div>
          </div>
        </div>
      </LightLayout>
    </div>
  )
}

const ImageOption = memo(
  ({
    option,
    index,
    onDelete,
    onUpdate,
  }: {
    option: IDraftImage | IImage
    onDelete: (index: number) => void
    onUpdate: (index: number, updates: Partial<IImage>) => void
    index: number
  }) => {
    const [updateIndexModalOpen, setUpdateIndexModalOpen] = useState(false)

    let url
    if ('imageFile' in option) {
      url = URL.createObjectURL(option.imageFile)
    } else {
      url = option.file
    }

    return (
      <div
        className={css.imageOption}
        style={{ backgroundImage: `url(${url})` }}
        data-rightanswer={option.rightAnswer}
        key={url}
      >
        {updateIndexModalOpen && (
          <UpdateOrderingIndexModal
            initialIndex={option.orderingIndex || 0}
            onChange={(val) => {
              setUpdateIndexModalOpen(false)
              onUpdate(index, { orderingIndex: val })
            }}
            onClose={() => setUpdateIndexModalOpen(false)}
          />
        )}
        <span className={taskSandboxCss.imageOptionOrderingIndex} onClick={() => setUpdateIndexModalOpen(true)}>
          Индекс: {option.orderingIndex || '-'}
        </span>
        <RemoveIcon onClick={() => onDelete(index)} className={css.cancel} />
      </div>
    )
  }
)

export default SixteenthTaskSandbox
